import * as React from 'react'
import { useCallback, useState } from 'react'
import { AlertDialogSlide, MoreButton } from '@sales-center/components'
import Button from '@mui/material/Button'
import { Role } from '@user/store/roles/typings'
import { GridDensity } from '@mui/x-data-grid-pro'

interface Props {
  role: Role
  handleEditClick: (role: Role) => void
  handleDeleteRequest: (id: number) => void
  densityMode?: GridDensity
}

export function ActionMenu(props: Props) {
  const { role, handleEditClick, handleDeleteRequest, densityMode } = props

  const [open, setOpen] = useState(false)
  const confirmDelete = useCallback(() => setOpen(true), [])
  const cancelDelete = useCallback(() => setOpen(false), [])

  const deleteClick = useCallback(() => {
    setOpen(false)
    handleDeleteRequest(Number(role.id))
  }, [handleDeleteRequest, role.id])

  return (
    <>
      <AlertDialogSlide
        open={open}
        title="Delete Role?"
        message="Are you sure you want to delete this role?"
        okButtonText="Delete"
        okClick={deleteClick}
        cancelButtonText="Cancel"
        cancelClick={cancelDelete}
      />
      <MoreButton
        dataTestId={`roleActionsMoreBtn-${role.id}`}
        style={{ color: '#091B2A8F' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        options={[
          {
            label: 'Delete',
            disabled: role.systemCreated || role.usersCount > 0,
            onClick: confirmDelete,
            tooltipText: role.systemCreated
              ? 'Cannot delete system created role'
              : role.usersCount > 0
                ? 'Remove all users that are using this role to delete it.'
                : undefined,
          },
        ]}
      />

      <Button
        color="primary"
        variant="outlined"
        onClick={() => handleEditClick(role)}
        size={densityMode === 'compact' ? 'small' : 'medium'}
        sx={{
          height: densityMode === 'compact' ? '25px' : 'unset',
        }}
      >
        Edit
      </Button>
    </>
  )
}
